import React, { useRef, useState, useEffect } from "react";
import "../../styles/Contact.css";
import { FiMapPin, FiMail, FiPhone } from "react-icons/fi";

import bannerImg from "../../assets/images/conts.webp";
import emailjs from "@emailjs/browser";
import { Link } from "react-router-dom";

const Contact = () => {
  const formRef = useRef();
  const [loading, setLoading] = useState(false);

  const user = "Connect";
  const domain = "empowerweb.com";
  const displayEmail = "connect@empowerweb.in";
  useEffect(() => {
    emailjs.init("YWyfWV3Y-YTiC109P");
  }, []);

  const showAlert = (type, message) => {
    const alertBox = document.createElement("div");
    alertBox.className = `custom-alert ${type}`;
    alertBox.innerHTML = `
      <span class="alert-icon">${type === "success" ? "✅" : "❌"}</span>
      <span class="alert-text">${message}</span>
    `;
    document.body.appendChild(alertBox);

    setTimeout(() => {
      alertBox.remove();
    }, 4500);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    emailjs
      .sendForm(
        "service_jlh6tvr",
        "template_20mxpjm",
        formRef.current,
        "YWyfWV3Y-YTiC109P",
      )
      .then(() => {
        showAlert(
          "success",
          "Message sent successfully! We'll contact you shortly.",
        );
        formRef.current.reset();
        setLoading(false);
      })
      .catch(() => {
        showAlert("error", "Failed to send message. Please try again later.");
        setLoading(false);
      });
  };

  return (
    <>
      <section className="banner">
        <div className="banner-content">
          <h1>
            Contact Empower Web – SEO & Digital Marketing Company in Noida
          </h1>
          <p>
            Contact Empower Web for expert search engine marketing, digital
            advertising and marketing, and web development offerings. Our team
            helps corporations grow online, generate quality leads, improve
            rankings, and increase sales.
          </p>
          <Link to="/contact">
            <button className="blogall-btn">Get Free Consultation →</button>
          </Link>
        </div>

        {/* <div className="banner-image">
          <img
            src={bannerImg}
            alt="Business Growth"
            width="600"
            height="400"
            loading="lazy"
            style={{ width: "100%", height: "auto" }}
          />
        </div> */}
        <div className="banner-image">
          <img
            src={bannerImg}
            alt="Business Growth"
            width="340"
            height="255"
            fetchpriority="high"
            decoding="async"
            style={{ width: "100%", height: "auto" }}
          />
        </div>
      </section>
      <div>
        <div className="breadcrumb">
          <Link to="/">Home</Link>
          <span> / </span>
          <span>Contact us</span>
        </div>
      </div>
      <section className="contact-section">
        <h2 className="contact-title">
          Get in Touch with Our SEO & Digital Marketing Experts
        </h2>
        <p className="contact-subtitle">
          Contact Empower Web for expert SEO, digital marketing, and web
          development services in Noida. Get free consultation and grow your
          business online faster. Fill the form below and our team will contact
          you within 24 hours.
        </p>

        <div className="contact-wrapper">
          <div className="contact-card">
            <h3>
              Noida <span className="tagz">Corporate Office</span>
            </h3>

            <p className="contact-line">
              <FiMapPin className="icon" />
              <br />
              <strong>Location :</strong> <br />
              Sector-62, Noida, India
            </p>

            <p className="contact-line">
              <FiMail className="icon" />
              <br />
              <strong>Email :</strong> <br />
              <a href={`mailto:${user}@${domain}`}>{displayEmail}</a>
            </p>

            <p className="contact-line">
              <FiPhone className="icon" />
              <br />
              <strong>Phone :</strong> <br />
              <a href="tel:+918368327503" className="phone-link">
                +91 8368327503
              </a>
              |
              <a href="tel:+919319563429" className="phone-link">
                +91 9319563429
              </a>
            </p>
          </div>

          {/* RIGHT FORM */}
          <form className="contact-form" ref={formRef} onSubmit={handleSubmit}>
            <div className="form-row">
              <input type="text" name="name" placeholder="Name *" required />
              <input
                type="email"
                name="email"
                placeholder="Email Id *"
                required
              />
            </div>

            {/* <div className="form-row">
              <input
                type="tel"
                name="phone"
                placeholder="Mobile No *"
                required
              />
              <select name="service" required>
                <option value="">Choose Services</option>
                <option value="SEO">SEO</option>
                <option value="Digital Marketing">Digital Marketing</option>
                <option value="Web Development">Web Development</option>
                <option value="Content Marketing">Content Marketing</option>
              </select>
            </div> */}
            <div className="form-row">
              <label htmlFor="phone" className="sr-only">
                Mobile Number
              </label>
              <input
                type="tel"
                id="phone"
                name="phone"
                placeholder="Mobile No *"
                required
              />

              <div className="form-field">
                <label htmlFor="service" className="sr-only">
                  Choose a Service
                </label>
                <select id="service" name="service" required>
                  <option value="">Choose Services</option>
                  <option value="SEO">SEO</option>
                  <option value="Digital Marketing">Digital Marketing</option>
                  <option value="Web Development">Web Development</option>
                  <option value="Content Marketing">Content Marketing</option>
                </select>
              </div>
            </div>

            <textarea name="message" placeholder="Type Your Message" required />

            <div className="form-footer">
              <button type="submit" className="submit-btn" disabled={loading}>
                {loading ? "Sending..." : " Get free consultation →"}
              </button>
            </div>
          </form>
        </div>
      </section>
      <section className="why-choose">
        <div className="container">
          <h2 className="why-title">Why Choose Empower Web</h2>
          <div className="why-grid">
            <div className="why-card">
              <h3>Experienced SEO Team</h3>
              <p>
                Our team has years of experience in SEO and digital marketing to
                help your business grow online.
              </p>
            </div>

            <div className="why-card">
              <h3>Result Driven Strategy</h3>
              <p>
                We focus on result-driven SEO and marketing strategies that
                generate leads and increase sales.
              </p>
            </div>

            <div className="why-card">
              <h3>Affordable Pricing</h3>
              <p>
                We offer high-quality digital marketing and SEO services at
                affordable pricing for businesses.
              </p>
            </div>

            <div className="why-card">
              <h3>Free Consultation</h3>
              <p>
                Get free consultation from our experts to understand how we can
                help grow your business.
              </p>
            </div>

            <div className="why-card">
              <h3>Local SEO Experts in Noida</h3>
              <p>
                We help local businesses rank higher on Google and get more
                customers from their area.
              </p>
            </div>

            <div className="why-card">
              <h3>24/7 Support</h3>
              <p>
                Our support team is always available to help you with your
                queries and support.
              </p>
            </div>

            <div className="why-card">
              <h3>Customized Marketing Plans</h3>
              <p>
                We create customized digital marketing plans based on your
                business goals.
              </p>
            </div>

            <div className="why-card">
              <h3>Transparent Reporting</h3>
              <p>
                We provide transparent monthly reports so you can track your SEO
                and marketing performance.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
